import { alpha } from '@mui/material';

const cobalt = {
  50: '#E3EDFD',
  100: '#BBD4FB',
  200: '#90B8F9',
  300: '#649CF6',
  400: '#4D7BF0',
  500: '#4361EE',
  600: '#3250D9',
  700: '#2842C7',
  800: '#233CB8',
  900: '#1D33A1',
  A100: '#BBD4FB',
  A200: '#90B8F9',
  A400: '#4D7BF0',
  A700: '#2842C7',
  // transparent cobalt that based on cobalt[500]
  A004: alpha('#4361EE', 0.04),
  A008: alpha('#4361EE', 0.08),
  A012: alpha('#4361EE', 0.12),
  A014: alpha('#4361EE', 0.14),
  A020: alpha('#4361EE', 0.2),
  A030: alpha('#4361EE', 0.3),
  A050: alpha('#4361EE', 0.5)
} as const;

const coral = {
  50: '#FCE3E3',
  100: '#FABBBB',
  200: '#ED8E8E',
  300: '#DD7373',
  400: '#BD6068',
  500: '#9E515C',
  600: '#8F4653',
  700: '#823D4E',
  800: '#753548',
  900: '#692d41',
  A100: '#FABBBB',
  A200: '#ED8E8E',
  A400: '#BD6068',
  A700: '#823D4E',
  // transparent coral that based on coral[500]
  A004: alpha('#9E515C', 0.04),
  A008: alpha('#9E515C', 0.08),
  A012: alpha('#9E515C', 0.12),
  A016: alpha('#9E515C', 0.16),
  A030: alpha('#9E515C', 0.3),
  A050: alpha('#9E515C', 0.5)
} as const;

const darkblue = {
  100: '#0049A6'
} as const;

const green = {
  100: '#6FCC5F'
} as const;

const lightblue = {
  100: '#4BA9ED'
} as const;

const mango = {
  50: '#FAE9E1',
  100: '#FBCDB8',
  200: '#FCA17D',
  300: '#F28561',
  400: '#F27349',
  500: '#F26130',
  600: '#EB5523',
  700: '#DB4716',
  800: '#CC3F10',
  900: '#B23309',
  A100: '#FBCDB8',
  A200: '#FCA17D',
  A400: '#F27349',
  A700: '#DB4716'
} as const;

const navi = {
  100: '#437A39'
} as const;

const pink = {
  100: '#F2A0C1'
} as const;

const purple = {
  100: '#B140E5',
  120: '#7A07b0'
} as const;

const steel = {
  50: '#F8F8F9',
  100: '#F0F0F2',
  200: '#E7E6E9',
  300: '#DBDADF',
  400: '#BAB7C4',
  500: '#9D9AA8',
  600: '#737080',
  700: '#615D70',
  800: '#403D4D',
  900: '#0D0628',
  A100: '#F0F0F2',
  A200: '#E7E6E9',
  A400: '#BAB7C4',
  A700: '#615D70',
  // transparent steel's that based on steel[900]
  A002: alpha('#0D0628', 0.02),
  A004: alpha('#0D0628', 0.04),
  A006: alpha('#0D0628', 0.06),
  A008: alpha('#0D0628', 0.08),
  A010: alpha('#0D0628', 0.1),
  A013: alpha('#0D0628', 0.13),
  A021: alpha('#0D0628', 0.21),
  A024: alpha('#0D0628', 0.24),
  A040: alpha('#0D0628', 0.4),
  A044: alpha('#0D0628', 0.44),
  A059: alpha('#0D0628', 0.59),
  A063: alpha('#0D0628', 0.63)
} as const;

const yellow = {
  100: '#F5C545'
} as const;

const white = {
  100: '#ffffff',
  A030: alpha('#ffffff', 0.3),
  A050: alpha('#ffffff', 0.5),
  A070: alpha('#ffffff', 0.7)
} as const;

const Colors = {
  cobalt,
  coral,
  darkblue,
  green,
  lightblue,
  mango,
  navi,
  pink,
  purple,
  steel,
  yellow,
  white
} as const;

export default Colors;
